import 'core-js/stable';
import {ConfigProvider} from 'vant';
import {createApp} from 'vue';
import {createWebHistory} from 'vue-router';
import {hideNavigationStatusBar} from '@/bridge';
import App from './App.vue';
import createRouter from './router';
import {initOpenAppSDK} from './plugins/initOpenAppSDK';
import {initSentry} from './plugins/initSentry';
import '@/assets/font/iconfont';

initOpenAppSDK();// 初始化 open-app-sdk

if (process.env.NODE_ENV !== 'production') {
  console.log(process.env);
  console.info('当前页面url:', window.location.href);
}

// 如果访问 /info 和 /detail 页面, 需要隐藏 titlebar 和状态栏
const {pathname} = window.location;
if (!pathname.startsWith('/study-info/outlink')) {
  hideNavigationStatusBar();
}

// 测试环境 加入 vconsole
if (process.env.NODE_ENV !== 'production' && !window.location.href.includes('localhost')) {
  const VConsole = require('vconsole');
  new VConsole();
}

export const app = createApp(App);
const router = createRouter(createWebHistory('/study-info/'));

initSentry(app);// 初始化 sentry

app.use(router)
  .use(ConfigProvider);

router.isReady().then(() => {
  app.mount('#app');
});
